import {
   DashboardContainer,
   DashboardContent,
} from '@forwardflow/components/Dashboard'
import useAuthUser from '@forwardflow/hooks/customHooks/useAuthUser'
import { EmailVerificationModal } from '@forwardflow/modals/EmailVerificationModal'
import { useEmailVerificationModalStore } from '@forwardflow/store/modal/emailVerificationModal'
import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { FubInboxInstallModal } from '@forwardflow/modals/FubInboxInstallModal'

const Dashboard = () => {
   const navigate = useNavigate()
   const location = useLocation()
   const { data: user } = useAuthUser({ revalidateOnMount: true })
   const { openEmailVerificationModal, closeEmailVerificationModal } =
      useEmailVerificationModalStore()

   // Modal state
   const [showFubModal, setShowFubModal] = useState(false)

   // Check for fubUserId param
   useEffect(() => {
      const params = new URLSearchParams(location.search)
      if (params.get('fubUserId')) {
         setShowFubModal(true)
      }
   }, [location.search])

   useEffect(() => {
      if (user) {
         if (user.verified !== true) {
            navigate('/verify-email?email=' + user.email)
         } else if (user.firstSignIn !== false) {
            openEmailVerificationModal({
               name: `${user.firstName} ${user.lastName}`,
            })
         } else {
            closeEmailVerificationModal()
         }
      }
   }, [user, openEmailVerificationModal, closeEmailVerificationModal, navigate])

   const handleInstall = () => {
      setShowFubModal(false)
      navigate(`/settings/integration${location.search}`)
   }

   const handleSkip = () => {
      setShowFubModal(false)
   }

   const ProfiledDashboardContent = Sentry.withProfiler(DashboardContent, {
      name: 'DashboardContent',
   })

   return (
      <>
         <DashboardContainer>
            <ProfiledDashboardContent />
         </DashboardContainer>
         <EmailVerificationModal />
         <FubInboxInstallModal
            open={showFubModal}
            onInstall={handleInstall}
            onSkip={handleSkip}
         />
      </>
   )
}

export default Dashboard
